import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Localized } from '../../../objects';

@Injectable()
export class ServiceTypeService {

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<ServiceType[]> {

    const p = new Promise<ServiceType[]>((resolve, reject) => {

      this.apiSvc.get("api/servicetype/", null).subscribe(
        (data: ServiceType[]) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

  });

  return p;
}

}

export class ServiceType {
  DisplayOrder: number;
  Id: string;
  Localized: Localized[];
}
